export const useAccentTitle = (text?: string | null) => {
    if (!text) {
        return '';
    }

    return text.replace(/\*\*(.*?)\*\*/g, (match, p1) => `<i>${p1}</i>`);
};
